module.exports = __webpack_public_path__ + "img/title4.a49f084c.png";